import { useState } from "react";
import {
  pal,
  hex2rgba,
  toPercent,
  mkOpts,
  ScoreRing,
  StatCard,
  ChartCard,
  NoData,
  PeriodTabs,
  mkHorizOpts,
  gradeBadge,
} from "../../Reusable_Components/Report";
import { Bar } from "react-chartjs-2";
import { Award, AlertTriangle } from "lucide-react";

export function StudentDetailContent({ student, category }) {
  const [subjectFilter, setSubjectFilter] = useState(null);
  if (!student) return null;

  const subjectList = student.subjectList || [];
  const isTop = category === "top";
  const categoryBadge = isTop
    ? { label: "Top Performer", color: "#059669", icon: <Award size={14} /> }
    : { label: "Needs Attention", color: "#ef4444", icon: <AlertTriangle size={14} /> };

  const active = subjectFilter
    ? subjectList.find((s) => s.subject === subjectFilter)
    : null;

  return (
    <div>
      <div className="adm-drawer-kpis">
        <div
          className="adm-drawer-category"
          style={{ color: categoryBadge.color, background: hex2rgba(categoryBadge.color, 0.1) }}
        >
          {categoryBadge.icon}
          <span>{categoryBadge.label}</span>
        </div>
        <div className="adm-drawer-kpi">
          <span>Attempts</span>
          <strong>{student.attempts ?? 0}</strong>
        </div>
        <div className="adm-drawer-kpi">
          <span>Avg Score</span>
          <strong>{student.avgPct ?? 0}%</strong>
        </div>
      </div>

      <div className="adm-drawer-chart-title">Subject breakdown — click a bar for chapters</div>

      {subjectList.length === 0 ? (
        <div className="adm-no-data">
          <span className="adm-no-data-text" style={{ color: "#94a3b8" }}>
            No attempted assignments yet for this student
          </span>
        </div>
      ) : (
        <div style={{ height: Math.max(subjectList.length * 34, 120) }}>
          <Bar
            data={{
              labels: subjectList.map((s) => s.subject),
              datasets: [
                {
                  data: subjectList.map((s) => s.avgPct),
                  backgroundColor: subjectList.map((s) => {
                    const c = pal(s.subject).solid;
                    return !subjectFilter || subjectFilter === s.subject ? c : hex2rgba(c, 0.25);
                  }),
                  hoverBackgroundColor: subjectList.map((s) => pal(s.subject).solid),
                  borderRadius: 6,
                  borderSkipped: false,
                  barThickness: 22,
                },
              ],
            }}
            options={mkHorizOpts({
              labelFn: (ctx) => `${subjectList[ctx.dataIndex].subject}: ${ctx.parsed.x}%`,
              clickFn: (_, els) => {
                if (!els.length) return;
                const sub = subjectList[els[0].index].subject;
                setSubjectFilter((p) => (p === sub ? null : sub));
              },
            })}
          />
        </div>
      )}

      {active && (
        <div className="adm-drawer-chapters">
          <div className="adm-drawer-chart-title">{active.subject} — chapters (lowest first)</div>
          {(active.chapters || []).map((c, i) => (
            <div key={i} className="adm-chapter-row">
              <span className="adm-chapter-name">{c.chapter}</span>
              <span className="adm-chapter-date">{c.date}</span>
              <span className="adm-chapter-marks">
                {c.marks ?? "-"}/{c.maxMarks ?? "-"}
              </span>
              <span className="adm-chapter-pct" style={{ color: gradeBadge(c.percentage).color }}>
                {c.percentage}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}